/**
 * API Services — All API calls in one place, organized by domain
 * Usage: import { authAPI, addressAPI, cartAPI, paymentAPI } from "@/api/services"
 */

import apiClient from "./client";

// ─── Helpers ──────────────────────────────────────────────────────────────────
const getUser = () => JSON.parse(localStorage.getItem("org") || "{}");

// ─── Auth ─────────────────────────────────────────────────────────────────────
export const authAPI = {
  sendOTP: (phone, origin) =>
    apiClient.post("/v1/users/initiate_login/", {
      username: phone,
      access_type: "CHECKOUT",
      domain: origin.replace("https://", ""),
    }),

  verifyOTP: (phone, otp, otpRef, origin) =>
    apiClient.post("/v1/users/logged_in/", {
      otp,
      otp_ref: otpRef,
      username: phone,
      access_type: "CHECKOUT",
      domain: origin.replace("https://", ""),
    }),
};

// ─── Address ──────────────────────────────────────────────────────────────────
export const addressAPI = {
  getAll: () => {
    const { uuid } = getUser();
    return apiClient.get(`/v1/users/${uuid}/addresses/`);
  },

  create: (payload) => {
    const { uuid } = getUser();
    return apiClient.post(`/v1/users/${uuid}/addresses/`, payload);
  },

  update: (addressUuid, payload) => {
    const { uuid } = getUser();
    return apiClient.post(`/v1/users/${uuid}/address/${addressUuid}/`, payload);
  },

  delete: (addressUuid) => {
    const { uuid } = getUser();
    return apiClient.post(
      `/v1/users/${uuid}/address-update/${addressUuid}/`,
      { status: "inactive" }
    );
  },
};

// ─── Cart ─────────────────────────────────────────────────────────────────────
export const cartAPI = {
  /**
   * POST /v1/org/checkout/{uuid}/cart/
   * Body: { cart_session_id: "hWN2mKzr..." }
   *
   * cart param from URL looks like: "hWN9Kt4ijoHa6zAjlSzMAFFs?key=xyz"
   * We strip everything after "?key=" to get the clean session id
   */
  fetch: (cartParam) => {
    const { uuid } = getUser();
    const cart_session_id = cartParam
      ? cartParam.split("?key=")[0]  // strip ?key=xxx if present
      : cartParam;
    return apiClient.post(`/v1/org/checkout/${uuid}/cart/`, {
      cart_session_id,
    });
  },
};

// ─── Payment ──────────────────────────────────────────────────────────────────
export const paymentAPI = {
  getMethods: () => {
    const { uuid } = getUser();
    return apiClient.get(`/v1/org/checkout/${uuid}/payment-methods/`);
  },

  initiate: (payload) => {
    const { uuid } = getUser();
    return apiClient.post(`/v1/org/payment/${uuid}/initiate/`, payload);
  },

  createOrder: (payload) => {
    const { uuid } = getUser();
    return apiClient.post(`/v1/org/checkout/${uuid}/create-order/`, payload);
  },

  verify: (payload) => {
    const { uuid } = getUser();
    return apiClient.post(`/v1/org/payment/${uuid}/verify/`, payload);
  },
};